import React from 'react';
import { Avatar, Chip } from '@mui/material';

export const FONT = 'Mulish, sans-serif';

export const authToken = () => {
  const raw = sessionStorage.getItem('token');
  return raw ? `Bearer ${raw}` : '';
};

export const STATUS = {
  approved: { bg: '#dcfce7', fg: '#166534', label: 'Approved' },
  rejected: { bg: '#fee2e2', fg: '#991b1b', label: 'Rejected' },
  pending: { bg: '#fef3c7', fg: '#92400e', label: 'Pending' },
  waitingForApproval: { bg: '#e0f2fe', fg: '#0369a1', label: 'Waiting for approval' },
};

export const StatusChip = ({ status }) => {
  const s = STATUS[status] || STATUS.pending;
  return <Chip size="small" label={s.label} sx={{ fontFamily: FONT, fontWeight: 700, height: 22, background: s.bg, color: s.fg }} />;
};

export const DOC_TYPES = [
  { id: 'gstProof', label: 'GST registration certificate' },
  { id: 'businessPanProof', label: 'Business PAN card' },
  { id: 'addressProof', label: 'Address proof (bill / rent agreement)' },
  { id: 'shopActLicense', label: 'Shop & establishment license' },
  { id: 'msmeUdyamCertificate', label: 'MSME / Udyam certificate' },
  { id: 'cancelledCheque', label: 'Cancelled cheque' },
];

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');

export const initialOf = (s) => (String(s?.name || s?.business_name || '').trim()[0] || 'S').toUpperCase();

export const SellerAvatar = ({ seller, size = 40 }) => (
  <Avatar sx={{ width: size, height: size, bgcolor: '#ffd102', color: '#000', fontWeight: 800, fontSize: size * 0.4 }}>{initialOf(seller)}</Avatar>
);

export const GST_RX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const PAN_RX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const IFSC_RX = /^[A-Z]{4}0[A-Z0-9]{6}$/;
